import { get, unauth_add, getIpgReportNew, post, auth_add } from "./common"
export const sign=async(body)=>{
    return await unauth_add("organization/portal/login/",body)
}
export const getALLevent = async () => {
    try {
      const data = await get('organization/dashboard/events/');
      return data;
      // Process the received data
    } catch (error) {
      // Handle error here
      return error;
    }
}
export const getEventDetails = async (eventId) => {
    try {
      const data = await get(`organization/dashboard/event-detail/?id=${eventId}`);
      return data;
      // Process the received data
    } catch (error) {
      // Handle error here
      return error;
    }
}

export const getPartiDetails =async(params)=>{
  return await get("organization/dashboard/event-participants/?" + params)
}
export const getNotifiesDetails =async(params)=>{
  return await get("organization/dashboard/list-dashboard/?" + params)
}
export const getDetailsById =async(params)=>{
  return await get("organization/dashboard/event-participant-detail/?" + params)
}
export const getEventS =async(params)=>{
  return await get("organization/dashboard/event-checking-status/?" + params)
}
export const geteventVolume = async (params) => {
    try {
      // const data = await get(`organization/dashboard/event-volume/?id=${eventId}`);
      const data = await get("organization/dashboard/event-volume/?" + params);
      return data;
      // Process the received data
    } catch (error) {
      // Handle error here
      return error;
    }
}
// export const download =async(params)=>{
//   return await getIpgReportNew("organization/dashboard/report/?event_id=" + params)
// }
// Dashboard service for downloading reports
export const download = async (params) => {
  const endpoint = `organization/dashboard/report/?event_id=${params}`;
  return await getIpgReportNew(endpoint);
};
export const downloadNotifyReport = async (params) => {
  const endpoint = `organization/dashboard/notify_report/?event_details=${params}`;
  return await getIpgReportNew(endpoint);
};
// resend
export const reSend =async(params)=>{
  // return await get("organization/dashboard/resend-event-confirmation?" + params)
  return await get("organization/dashboard/resend-event-confirmation?" + params)
}
export const getTickent =async(params)=>{
  return await get("organization/dashboard/tickets-by-slot/?" + params)
}
export const ticketUpgradeVerify = async (queryParams, body) => {
  return await post("organization/dashboard/ticket-upgrade/", body, queryParams);
};
export const ticketUpgradeConfirm = async (queryParams, body) => {
  return await post("organization/dashboard/ticket-upgrade/confirm/", body, queryParams);
};
export const ticketUpgradeResendConfirmation = async (body) => {
  return await post("organization/dashboard/ticket-upgrade/resend-confirmation/", body);
};
export const ticketCancellationPreview = async (queryParams, body) => {
  return await post("organization/dashboard/ticket-cancellation/", body, queryParams);
};
export const ticketCancellationConfirm = async (queryParams, body) => {
  return await post("organization/dashboard/ticket-cancellation/confirm/", body, queryParams);
};

export const refundRequest = async (transactionId) => {
  return await auth_add("organization/dashboard/refund-request/", {
    transaction_id: transactionId,
  });
}
